var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluecheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00098 0C7.18766 0 8.3477 0.351894 9.3344 1.01118C10.3211 1.67047 11.0901 2.60754 11.5443 3.7039C11.9984 4.80026 12.1172 6.00666 11.8857 7.17054C11.6542 8.33443 11.0827 9.40353 10.2436 10.2426C9.4045 11.0818 8.3354 11.6532 7.17152 11.8847C6.00763 12.1162 4.80123 11.9974 3.70488 11.5433C2.60852 11.0892 1.67145 10.3201 1.01216 9.33342C0.35287 8.34673 0.000976563 7.18669 0.000976562 6C0.000976563 4.4087 0.633118 2.88258 1.75834 1.75736C2.88355 0.632141 4.40968 0 6.00098 0Z",
    fill: "#203662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90798 7.32301L3.48498 5.90001L3.00098 6.38101L4.90798 8.28801L9.00098 4.19401L8.51998 3.71301L4.90798 7.32301Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecheckbox);
export default __webpack_public_path__ + "static/media/bluecheckbox.4f57211492378ba155d8edbef9ffedea.svg";
export { ForwardRef as ReactComponent };